import { render, staticRenderFns } from "./b2.vue?vue&type=template&id=9b1dd9b6&scoped=true&"
import script from "./b2.vue?vue&type=script&lang=js&"
export * from "./b2.vue?vue&type=script&lang=js&"
import style0 from "./b2.vue?vue&type=style&index=0&id=9b1dd9b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1dd9b6",
  null
  
)

export default component.exports